
import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import NotificationsManager from './NotificationsManager';

const title = 'Gestor de Notificaciones';

export default async function action({ store }) {
  // Check auth similar to adminDashboard
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }
  
  return {
    title,
    component: (
      <AdminLayout>
        <NotificationsManager title={title} />
      </AdminLayout>
    ),
  };
}
